// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WTlNvQ1wJwKTQPpeYhUE{height:100%;max-height:100%;padding-left:48px}.kxc2OnCjwPUle7wXgYfp{height:100%;max-height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WTlNvQ1wJwKTQPpeYhUE`,
	"containerV2_2": `kxc2OnCjwPUle7wXgYfp`,
	"containerV22": `kxc2OnCjwPUle7wXgYfp`
};
export default ___CSS_LOADER_EXPORT___;
